module.exports = __webpack_public_path__ + "img/BE0713629988.ddb0774a.png";